import React from 'react';
import { FaQuoteRight } from 'react-icons/fa';
import './MeetTheTeam.css';
import headshot1 from '../images/headshot1.jpg';
import headshot2 from '../images/headshot2.jpg';

export default function MeetTheTeam() {
  return (
    <section className="meet-the-team">
      <h2 className="mtl-heading">Voices of Our Leaders</h2>
      <div className="team-grid">
        <div className="team-card">
          <img src={headshot2} alt="Gurmeet Dhillon" className="team-photo" />
          <h3 className="team-name">Gurmeet S. Dhillon, PE</h3>
          <p className="team-role">Founder</p>
          <p className="team-quote">
            When I started this company, my goal was to use civil, mechanical, and electrical
            engineering to build with honesty and care. For me, engineering was never just about
            projects, but about improving people’s lives. I’m proud that the hard work and values we
            built on will continue, even though I have passed the company to new hands.
          </p>
          <FaQuoteRight className="quote-icon" />
        </div>

        <div className="team-card">
          <img src={headshot1} alt="Ashok Mathur" className="team-photo" />
          <h3 className="team-name">Ashok K. Mathur, PE, LEED® AP BD+C</h3>
          <p className="team-role">President</p>
          <p className="team-quote">
            Building on the strong foundation left by Mr. Dhillon, I plan on building for the future
            generations to come and carry our engineering principles towards the future, and to
            continue to provide multidisciplinary services to our current and future clients with
            technology and sustainability playing a crucial role.
          </p>
          <FaQuoteRight className="quote-icon" />
        </div>
      </div>
    </section>
  );
}
